export const brushes = [
  'Pencil',
  'Eraser',
  'Crayon',
  'Ink',
  // "Marker",
  'Spray',
  'Web',
  'Fur',
  // "Longfur",
  'Ribbon',
  'Sketchy',
  'Squares',
  'Shaded',
  'Circle',
  'Pattern',
  'hline',
  'vline',
  'square',
];
